import { useState } from 'react'
import { OnboardingModal } from './OnboardingModal'
import { onboardingDone } from '../lib/onboardingBridge'

/**
 * The first-visit picker as hydrated onto index.html's static copy (see
 * main.tsx and lib/onboardingBridge). Renders OnboardingModal open, so its
 * first render has to match the markup bootPicker in vite.config.ts writes.
 */
export function BootPicker({ container }: { container: HTMLElement }) {
  const [open, setOpen] = useState(true)
  return (
    <OnboardingModal
      open={open}
      onDone={(slugs) => {
        setOpen(false)
        container.hidden = true
        onboardingDone(slugs)
      }}
    />
  )
}
